import { render, staticRenderFns } from "./CoordinatorsList.vue?vue&type=template&id=1f05e089&scoped=true&"
import script from "./CoordinatorsList.vue?vue&type=script&lang=js&"
export * from "./CoordinatorsList.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorsList.vue?vue&type=style&index=0&id=1f05e089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05e089",
  null
  
)

export default component.exports